module.exports = __webpack_public_path__ + "img/kefu1.1d9c3170.png";